{
	"main": {
		"title": "Lista di decollo aliante",
		"nezakljuceni": "VOLI NON COMPLETATI",
		"zakljuceni": "VOLI COMPLETATI"
	},
	"table": {
		"reg": "REG.",
		"titleJ": "Elenco dei voli a vela",
		"datum": "DATA",
		"vzlet": "DECOLLO",
		"pilot": "PILOTA",
		"naloga": "COMPITO",
		"pristanek": "ATTERRAGGIO"
	},
	"labels": {
		"datumOd": "Data DA:",
		"datumDo": "Data A:",
		"pilotJ": "Seleziona pilota dell'aliante:",
		"instruktor": "Seleziona istruttore dell'aliante:",
		"registracijaJ": "Seleziona reg. aliante:",
		"namenJ": "Seleziona scopo:",
		"nalogaJ": "Seleziona compito del volo a vela:",
		"pilotM": "Seleziona pilota dell'aereo traino:",
		"registracijaM": "Seleziona reg. aereo traino:",
		"vzlet": "Seleziona decollo:",
		"pristanek": "Seleziona atterraggio:",
		"poletanje": "Decollo:",
		"odklop": "Distacco:",
		"nezakljucen": "Volo non completato?",
		"pristanekJ": "Atterraggio dell'aliante:",
		"pristanekM": "Atterraggio dell'aereo traino:",
		"opomba": "Nota"
	},
	"modal": {
		"registracija": "registrazione",
		"pilot": "pilota",
		"regVleke": "reg. traino:",
		"instruktor": "istruttore:",
		"namen": "scopo:",
		"naloga": "compito:",
		"casVzleta": "ora decollo:",
		"casOdklopa": "ora distacco:",
		"casPristanka": "ora atterraggio:",
		"casLetenja": "durata volo:",
		"casVleke": "durata traino:",
		"opomba": "nota:",
		"datumL": "data volo:",
		"datumV": "data inserimento:"
	},
	"edit": {
		"titleJ": "DATI ALIANTE",
		"regJ": "registrazione aliante:",
		"pilotJ": "pilota aliante:",
		"instruktor": "istruttore:",
		"namenJ": "scopo aliante:",
		"nalogaJ": "compito aliante:",
		"titleM": "DATI AEREO TRAINO",
		"pilotM": "pilota aereo traino:",
		"regM": "registrazione aereo traino",
		"titleS": "DATI GENERALI",
		"krajV": "luogo decollo:",
		"krajP": "luogo atterraggio:",
		"casV": "ora decollo:",
		"casO": "ora distacco:",
		"casPJ": "ora atterraggio aliante:",
		"casPM": "ora atterraggio aereo traino:",
		"opomba": "Nota:"
	},
	"modalNL": {
		"title": "Completa il record selezionato",
		"regJ": "registrazione:",
		"pilotJ": "pilota:",
		"regM": "reg. traino:",
		"instruktor": "istruttore",
		"namen": "scopo:",
		"naloga": "compito:",
		"casV": "ora decollo:",
		"casO": "ora distacco:",
		"pristanekJ": "Atterraggio aliante:",
		"casVL": "durata traino:",
		"opomba": "nota:",
		"datumL": "data volo:",
		"datumV": "data inserimento:"
	},
	"buttons": {
		"zakljuciLet": "Concludi il volo",
		"brisiIzbiro": "Cancella selezione",
		"urediPodatke": "Modifica dati",
		"posodobiPodatke": "Aggiorna dati",
		"izbrisiZapis": "Elimina record",
		"csv": "Esporta in CSV",
		"natisni": "Stampa",
		"poslji": "Invia"
	},
	"data": {
		"title": "Dati",
		"stPristankov": "N. atterraggi:",
		"stLetov": "N. voli:",
		"casVZraku": "Durata:"
	},
	"obvestila": {
	  "zapisPrihodnost": "Il record ha una data impostata nel futuro. CORREGGI la data selezionata!",
	  "zapisCasPrihodnost": "Una o più registrazioni hanno un'ora impostata nel futuro, controlla gli orari!",
	  "zapisCasNapaka": "Gli orari delle registrazioni non sono corretti! Controlla di nuovo gli orari!",
	  "napakaPristanka": "L'orario di atterraggio non può essere prima dell'orario di decollo!",
	  "zapisPobrisan": "Record eliminato con successo",
	  "napakaPrazenPristanek": "Errore di inserimento, l'orario di atterraggio non può essere vuoto",
	  "posodobitevUspesna": "Aggiornamento riuscito",
	  "napakaPosodabljanja": "Errore durante l'aggiornamento dei dati.",
	  "napakaBranja": "Errore durante la lettura dei dati.",
	  "napakaIzbrisa": "Errore durante l'eliminazione dei dati.",
	  "vprasanjeIzbris": "Sei sicuro di voler eliminare il record?",
	  "napakaVnosa": "Errore di inserimento, controlla che tutti i campi siano compilati!",
	  "letZakljucen": "Volo completato con successo.",
	  "letNiZakljucen": "Errore durante il completamento del volo."
	}
}